import { call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { notificationInit } from '../../modules/notifications/actions';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { getAutoparksTransportsRequest, updateAutoparkTransportAllowRequest } from '../../api/requests';
import {
	GET_AUTOPARKS_TRANSPORTS,
	setAutoparksTransportsAction,
	setIsAutoparksTransportsLoadingAction,
	setPaginationAction,
	UPDATE_AUTOPARK_TRANSPORT_ALLOW,
} from './actions';
import { DISMISS_TIME } from '../../api/constants';
import { errorHandler } from '../../api/utils';
import { removeModalQuery } from '../../utils/removeModalQuery';
import { getAutoparksTransportsAllowSelector } from './selectors';

export function* getAutoparksTransportsSaga({ payload: { searchQuery, autoparkId } }) {
	try {
		yield put(setIsAutoparksTransportsLoadingAction(true));

		const query = new URLSearchParams(searchQuery);
		query.delete('filters');
		query.delete('sorts');

		const str = removeModalQuery(
			query.toString().replace('childrenSorts', 'sorts').replace('childrenFilters', 'filters'),
		);

		const { data, message, meta, toast } = yield call(
			getAutoparksTransportsRequest,
			`${str ? `${str}&receive=all` : '?receive=all'}`,
			autoparkId,
		);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			const query = new URLSearchParams(searchQuery);
			query.set('modal', 'transport');
			query.delete('mode');

			yield put(
				setAutoparksTransportsAction(
					data?.map(autoparkTransport => {
						query.set('transportId', autoparkTransport.id);

						return {
							...autoparkTransport,
							link: `?${query.toString()}`,
						};
					}),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsAutoparksTransportsLoadingAction(false));
	}
}

export function* updateAutoparkTransportAllowSaga({ payload: { autoparkId, transportId, value, searchQuery } }) {
	try {
		const { data, message, toast } = yield call(
			updateAutoparkTransportAllowRequest,
			{ is_allow: value },
			autoparkId,
			transportId,
		);

		if (data) {
			if (toast) {
				yield put(
					notificationInit({
						id: uuidv4(),
						dismissAfter: DISMISS_TIME,
						...toast,
						...(toast?.link ? { link: `${toast?.link}${searchQuery ? `&${searchQuery}` : ''}` } : {}),
					}),
				);
			}

			const transports = yield select(getAutoparksTransportsAllowSelector());

			yield put(
				setAutoparksTransportsAction(
					transports.map(transport => {
						if (transport.id === data.id) {
							transport.is_allow = data.is_allow;
						}

						return transport;
					}),
				),
			);
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	}
}

export default function* autoparksTransportsSaga() {
	yield takeEvery(GET_AUTOPARKS_TRANSPORTS, getAutoparksTransportsSaga);
	yield takeEvery(UPDATE_AUTOPARK_TRANSPORT_ALLOW, updateAutoparkTransportAllowSaga);
}
